module.exports = __webpack_public_path__ + "img/cydcbg.80d9b0b.80d9b0b5.jpg";